import { useMutation } from '@tanstack/react-query'
import api from '../../config/axios-config'
import { authorization } from '../../../containers/authentication/constants'
import { useAuthStore } from '../../../zustand/authentication/use-auth-store'
import { authMutationKeys } from '../constants'

export const useLoginMutation = (options) => {
  const { setPasswordPolicy, loginSuccessful, setShow2FA } = useAuthStore()

  const handleLoginCredentials = async (email, password) => {
    const config = {
      method: 'post',
      headers: {
        Authorization: authorization
      },
      data: {
        username: email,
        password,
        grant_type: 'password'
      }
    }

    const { data } = await api('/api/oauth/token', config)

    return data
  }

  const handleTwoFactor = async (email) => {
    const config = {
      method: 'get',
      params: {
        email
      },
      headers: null
    }

    const { data } = await api('/api/twoFactor', config)

    return data
  }

  const handleMfa = async (email) => {
    const config = {
      method: 'get',
      params: {
        email
      }
    }

    const { data } = await api('/api/mfa-api/sms', config)

    return data
  }

  const handleMutation = async ({ email, password }) => {
    const twoFaStatus = await handleTwoFactor(email)

    if (twoFaStatus) {
      setPasswordPolicy(twoFaStatus)
      if (twoFaStatus.sms || twoFaStatus.otp) {
        if (twoFaStatus.sms) {
          await handleMfa(email)
        }
        setShow2FA(twoFaStatus)
      } else {
        const dataLogin = await handleLoginCredentials(email, password)
        if (dataLogin) {
          loginSuccessful(dataLogin)
          return dataLogin
        }
      }
    }
  }

  return useMutation({
    mutationFn: handleMutation,
    mutationKey: authMutationKeys.LOGIN,
    retry: false,
    ...options
  })
}
